module.exports = __webpack_public_path__ + "img/@team_img_03_.d7dae1e8.jpg";